import React, { useState, useContext } from 'react';
import { FaCheck } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { saveAs } from 'file-saver';
import { Formik } from 'formik';

import { OrderContext } from '../../../context/orderContext';
import { FarmContext } from '../../../context/farmContext';

import { DownloadIcon } from '../../Icons';
import FormInput from '../../form/input';
import FormButton from '../../form/button';
import Summations from './Summations';
import FarmItems from './FarmItems';
import Card from './Card';

import Congratulations from '../../../images/congratulatioins.svg';

const FarmConfirm = ({
  order,
  cost,
  vat,
  packageTitle,
  token,
  firstName,
  setUnexpectedError,
  setSession
}) => {
  const { downloadPDF } = useContext(OrderContext);
  const { nameYourFarm } = useContext(FarmContext);

  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  return (
    <div>
      <FarmItems
        title="Enjoy your digital farming experience"
        subtitle={`${
          !order.isOffline
            ? 'How about you give your farm a name…'
            : 'Download your payment invoice below!'
        }`}
        name={firstName}
      >
        {!order.isOffline ? (
          <div className="w-full md:w-1/2 md:pr-2 mx-auto">
            <Card title="Congratulations!" green>
              <p>Your payment has been successful.</p>
              <img className="w-32 mx-auto my-4" src={Congratulations} alt="Congratulations" />
              {!success ? (
                <Formik
                  initialValues={{
                    name: '',
                    order: order._id
                  }}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      setSubmitting(true);
                      const response = await nameYourFarm(values);
                      setSubmitting(false);
                      if (response.code === 200) {
                        setSuccess(response.message);
                        setError(null);
                      } else {
                        setError(response.data.message);
                      }
                    } catch (error) {
                      if (error && error.status === 401) setSession(false);
                      else {
                        setUnexpectedError('Unexpected Network Error!');
                      }
                    }
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting
                  }) => (
                    <form className="flex justify-center flex-col" onSubmit={handleSubmit}>
                      <FormInput
                        className="w-full md:w-56 mx-auto my-4"
                        type="text"
                        name="name"
                        placeholder="John's Farm"
                        error={errors.name}
                        inputValue={values.name}
                        touched={touched.name}
                        change={handleChange}
                        blur={handleBlur}
                        title="Give your farm a name"
                        inputType
                      />
                      <p className="text-xs flex mx-auto">
                        Hit Enter(Ok or
                        <FaCheck />)
                      </p>
                    </form>
                  )}
                </Formik>
              ) : (
                <p className="text-xs text-cf-300">{success}</p>
              )}
              {error && <p className="text-xs text-red-500">{error}</p>}
            </Card>
          </div>
        ) : (
          <>
            <div className="w-full md:w-1/2 md:pr-2 mb-10 md:mb-0">
              <Card title="Download Payment Ticket!" green>
                <p>Your Order has been saved!</p>
                {!success ? (
                  <Formik
                    initialValues={{
                      pdfType: 'invoice'
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                      try {
                        setSubmitting(true);
                        const response = await downloadPDF(order._id, values.pdfType, token);
                        setSubmitting(false);
                        if (response.status === 200) {
                          const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
                          saveAs(pdfBlob, `${order.refKey}-invoice-for-${firstName}.pdf`);
                          setSuccess('Download Successful');
                          toast.success('Download Completed', {
                            position: toast.POSITION.TOP_RIGHT
                          });
                          setError(null);
                        } else {
                          if (response.response.status === 400) setError('Failed to download');
                        }
                      } catch (error) {
                        if (error && error.status === 401) setSession(false);
                        else {
                          setUnexpectedError('Unexpected Network Error!');
                        }
                      }
                    }}
                  >
                    {({ handleSubmit, isSubmitting }) => (
                      <form className="flex flex-wrap justify-center" onSubmit={handleSubmit}>
                        <FormButton
                          loading={isSubmitting}
                          name="Download"
                          color="bg-cf-300"
                          icon={
                            <DownloadIcon
                              styles={{
                                margin: '2px 5px 0 0',
                                size: '12px',
                                verticalAlign: 'middle'
                              }}
                            />
                          }
                          btnPad={'px-4 py-3 my-4'}
                          className="w-1/2"
                        />
                      </form>
                    )}
                  </Formik>
                ) : (
                  <p className="text-xs text-cf-300">{success}</p>
                )}
                {error && (
                  <>
                    <p className="text-sm">Couldn't download this invoice?</p>
                    <p className="text-sm text-red-500">Retry or Contact support.</p>
                  </>
                )}
              </Card>
            </div>
            <div className="w-full md:w-1/2 md:pl-2">
              <Card title="Payment summation" border>
                <Summations cost={cost} vat={vat} packageTitle={packageTitle} />
              </Card>
            </div>
          </>
        )}
      </FarmItems>
    </div>
  );
};

export default FarmConfirm;
